import React from "react";
import FieldTag from "../../../Pages/Form/FieldTags/FieldTag";
import { getFieldIcon } from "../../../utils/getFieldIcon";
import MaterialIcon from "../MaterialIcon";

const FormPreview = ({ data }) => {
  return (
    <div className="form_field_container">
      <label className="builder_label">
        <strong>{data.name}</strong>
      </label>
      <div className="form_field_outer" style={{ transformOrigin: "top", transform: "scale(0.6)" }}>
        <div className="overlay_cover"></div>
        {data.fields.length > 0 && (
          <div className="entity_form_container">
            {data.fields.map((field) => {
              const { ...fieldWithoutKey } = field;
              return (
                <div key={field.id} className={`single_field_render`}>
                  <MaterialIcon name={getFieldIcon(field.type)} className="mr_3" style={{ color: "#667085" }} />
                  <div className="form_element_container">
                    <FieldTag key={field.id} element={fieldWithoutKey} />;
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default FormPreview;
